import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { class: "footer-columns" }
const _hoisted_3 = { class: "footer-column" }
const _hoisted_4 = { href: "#" }
const _hoisted_5 = { href: "#" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = { href: "#" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "footer-column" }
const _hoisted_11 = { href: "#" }
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { href: "#" }
const _hoisted_14 = { href: "#" }
const _hoisted_15 = { href: "#" }
const _hoisted_16 = { class: "footer-column" }
const _hoisted_17 = { href: "#" }
const _hoisted_18 = { href: "#" }
const _hoisted_19 = { href: "#" }
const _hoisted_20 = { class: "footer-column" }
const _hoisted_21 = { class: "subscribe-form" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { type: "submit" }
const _hoisted_24 = { class: "social-icons" }
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]

import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalFooter',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_el_footer = _resolveComponent("el-footer")!

  return (_openBlock(), _createBlock(_component_el_footer, { class: "global-footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('footerProducts')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_4, _toDisplayString(_unref(t)('electricMotorcycles')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_5, _toDisplayString(_unref(t)('motorcycleParts')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(t)('batteryExchange')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(t)('evChargers')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)('evCables')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_9, _toDisplayString(_unref(t)('evAdapters')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('footerCommercialSolutions')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(t)('homeChargingSolutions')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(t)('evCharging')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)('commercialChargingSolutions')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(t)('engineeringProjects')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_15, _toDisplayString(_unref(t)('latestNews')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('footerQuickLinks')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_17, _toDisplayString(_unref(t)('blog')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_18, _toDisplayString(_unref(t)('videos')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_19, _toDisplayString(_unref(t)('aboutUs')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('footerSubscribe')), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeDescription')), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                type: "email",
                placeholder: _unref(t)('yourEmail')
              }, null, 8, _hoisted_22),
              _createElementVNode("button", _hoisted_23, _toDisplayString(_unref(t)('subscribeButton')), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("a", {
                href: "https://www.facebook.com/profile.php?id=61577205355724",
                target: "_blank",
                title: _unref(t)('facebook')
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "icon-facebook" }, "f", -1)
              ]))], 8, _hoisted_25),
              _createElementVNode("a", {
                href: "https://www.instagram.com/dr_moto_ev_hk_ltd/",
                target: "_blank",
                title: _unref(t)('instagram')
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "icon-instagram" }, "in", -1)
              ]))], 8, _hoisted_26),
              _createElementVNode("a", {
                href: "whatsapp://send?phone=+85266860815",
                target: "_blank",
                title: _unref(t)('whatsapp')
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "icon-whatsapp" }, "w", -1)
              ]))], 8, _hoisted_27),
              _createElementVNode("a", {
                href: "#",
                target: "_blank",
                title: _unref(t)('tiktok')
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "icon-tiktok" }, "t", -1)
              ]))], 8, _hoisted_28)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})